module.exports = __webpack_public_path__ + "img/Payment-At-Premises.d06ff6eb.jpg";